import React from 'react';
import { motion } from 'framer-motion';
import { FaPalette, FaCamera, FaVideo } from 'react-icons/fa';

const ServicesPage = () => {
  const services = [
    {
      title: "Graphic Design",
      icon: <FaPalette className="text-4xl mb-4" />,
      description: "Transform your ideas into stunning visual designs. From brand identity to marketing materials, we create compelling graphics that capture attention and communicate your message effectively.",
      features: [
        "Brand Identity Design",
        "Logo Design",
        "Social Media Graphics",
        "Print Materials",
        "Marketing Collateral",
        "UI/UX Design"
      ]
    },
    {
      title: "Photography",
      icon: <FaCamera className="text-4xl mb-4" />,
      description: "Capture your special moments with professional photography services. Whether it's portraits, events, or commercial shoots, we deliver high-quality images that tell your story.",
      features: [
        "Portrait Photography",
        "Event Photography",
        "Commercial Photography",
        "Product Photography",
        "Fashion Photography",
        "Real Estate Photography"
      ]
    },
    {
      title: "Videography",
      icon: <FaVideo className="text-4xl mb-4" />,
      description: "Bring your vision to life with our professional videography services. From concept to final edit, we create engaging video content that resonates with your audience.",
      features: [
        "Commercial Videos",
        "Event Coverage",
        "Music Videos",
        "Corporate Videos",
        "Social Media Content",
        "live Steaming"
      ]
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Services</h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Professional creative services to bring your vision to life
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              variants={itemVariants}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="text-black mb-6">
                {service.icon}
              </div>
              <h2 className="text-2xl font-bold mb-4">{service.title}</h2>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <span className="w-2 h-2 bg-black rounded-full mr-2"></span>
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
      {/* Decorative Divider */}
      <div className="-mb-1">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-16">
          <path fill="#F3F4F6" fillOpacity="1" d="M0,64L48,58.7C96,53,192,43,288,53.3C384,64,480,96,576,101.3C672,107,768,85,864,74.7C960,64,1056,64,1152,69.3C1248,75,1344,85,1392,90.7L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z" />
        </svg>
      </div>
     
    </section>
  );
};

export default ServicesPage; 